<template>
  <div class="community-list-container" :class="{'blog-container': currentTab === 1}">
    <div class="community-header flex-start">
      <div class="tab-wrapper flex-start">
        <w-tab :tab-list="tabList" :current-tab="currentTab" @changeTab="changeTab"></w-tab>
      </div>
      <div class="community-header-middle flex-start" @click="toSearchPage">
        <span class="iconfont iconsearch" @click="toSearchPage"></span>
        <!--        <span class="search-placeholder">请输入话题</span>-->
      </div>
      <div class="community-message" @click="goToMessage">
        <span class="iconfont iconxiaoxi"></span>
        <!--        <div class="message-total flex-center" v-if="messageCount" :style="{right:messageCount>99?'-14px':'-6px'}">-->
        <!--          {{messageCount > 99 ? '99+' : messageCount}}-->
        <!--        </div>-->
      </div>
    </div>
    <template v-if="!loadingShow">
      <div class="community-list-content" v-if="currentTab === 0">
        <cube-scroll :data="[currentTab]" :options="options" :scroll-events="scrollEvents" @pulling-up="onPullingUp"
                     @pulling-down="onPullingDown" ref="newListScroll">
          <div class="community-message-notice-container flex-center" v-if="messageCount">
            <div class="community-message-notice" @click="goToMessage">有 {{ messageCount }} 条新动态消息</div>
          </div>
          <div class="topic-content">
            <cube-scroll :data="[topicList]" :options="{ click: false }" direction="horizontal"
                         class="horizontal-scroll-list-wrap" ref="topicScroll">
              <div class="list-wrapper topic-wrapper">
                <template v-for="(item, index) in topicList">
                  <div class="list-item topic-item" :key="index" @click.stop="toTopicDetail(item)">
                    <div class="flex-column-center topic-item-text">
                      <img v-if="item.image" :src="item.image" alt="">
                      <img v-else src="https://files.wondercv.com/community/article-bg.png" alt="">
                      <span class="topic-text">{{item.interactive_count}}人参与讨论</span>
                    </div>
                  </div>
                </template>
              </div>
            </cube-scroll>
          </div>
          <template v-for="(item, index) in newList">
            <community-item :community-data="item" :key="index" @showBigImg="showBigImg"></community-item>
          </template>
          <w-more-loading v-show="moreLoadingShow"/>
          <!--          <w-no-more v-show="noMoreShow"/>-->
        </cube-scroll>
      </div>
      <div class="community-list-content" v-if="currentTab === 1">
        <cube-sticky :pos="scrollY">
          <cube-scroll @scroll="scrollHandler" :scroll-events="scrollEvents" :data="[blogList]" :options="options"
                       @pulling-up="onPullingUp" @pulling-down="onPullingDown" ref="communityScroll">
            <div class="head-images-content">
              <cube-slide :data="headImages" :options="{ click: false }">
                <cube-slide-item v-for="(item, index) in headImages" :key="index">
                  <div class="head-image-container flex-center">
                    <img @click="toBlogDetail(item)" class="head-image-item" :src="item.img" alt="">
                  </div>
                </cube-slide-item>
                <template slot="dots" slot-scope="props">
                    <span class="my-dot" :class="{'active': props.current === index}"
                          v-for="(item, index) in headImages.length"
                          :key="index"></span>
                </template>
              </cube-slide>
            </div>
            <cube-sticky-ele>
              <cube-scroll :data="blogTags" direction="horizontal" class="horizontal-scroll-list-wrap"
                           :options="{ click: false }">
                <div class="list-wrapper tags-wrapper">
                  <template v-for="(item, index) in blogTags">
                    <div class="list-item tag-item" :class="{'tag-item-active': index === currentIndex}" :key="index"
                         @click="changeTag(item, index)">{{ item.name }}
                    </div>
                  </template>
                </div>
              </cube-scroll>
            </cube-sticky-ele>
            <template v-for="(item, index) in blogList">
              <blog-item :key="index" :data="item"></blog-item>
            </template>
            <w-more-loading v-show="moreLoadingShow"/>
            <w-no-more v-show="noMoreShow"/>
          </cube-scroll>
        </cube-sticky>
      </div>
      <div class="community-add flex-center" v-show="!releaseState && currentTab === 0&&!bigImgState && alreadyLogged"
           @click="showRelease">
        <span class="iconfont iconplus2"></span>
      </div>
      <div v-if="!!alreadyLogged === false" class="unLogin">
        <span @click="toLogin">登录/注册</span>
        <p>登录名企校招小程序，查看更多校招职位</p>
      </div>
      <w-popup :state="releaseState">
        <release slot="content" :topicId="-1" :state="releaseState" @closeRelease="closeRelease"></release>
      </w-popup>
      <w-no-results text="暂时没有动态~" v-show="newList.length === 0"></w-no-results>
    </template>
    <w-loading v-else/>
    <w-tab-bar page="blog"></w-tab-bar>
    <div class="big_img_container">
      <big-img-popup :state="bigImgState">
        <big-img slot="content" :state="bigImgState" :imgIndex="imgIndex" :imgList="imgList"
                 :isDel='false' @closeBigImg="bigImgState=false"></big-img>
      </big-img-popup>
    </div>
    <w-user-dialog/>
  </div>
</template>

<script>
  import WTab from '../../../components/global/w-tab'
  import WTabBar from '../../../components/global/w-tabbar'
  import communityItem from '../components/community-item'
  import blogItem from '../components/blog-item'
  import WMoreLoading from '../../../components/global/w-more-loading'
  import WNoMore from '../../../components/global/w-no-more'
  import WLoading from '../../../components/global/w-loading'
  import Release from '../components/release'
  import WPopup from '../../../components/global/w-popup'
  import {mapActions, mapState, mapMutations} from 'vuex'
  import {envMixin, loginMixin} from '../../../assets/js/mixin/global'
  import {communityMixin} from '../../../assets/js/mixin/community'
  import {userMixin} from "../../../assets/js/mixin/user";
  import WNoResults from '../../../components/global/w-no-result'
  import BigImgPopup from '../components/big-img-popup'
  import BigImg from '../components/big-img'
  import community from "../../../api/api-list/community";
  import {addClass, removeClass} from "../../../assets/js/dom"
  import bbsApi from "../../../api/api-list/bbs"
  import WUserDialog from "../../../components/global/w-user-dialog.vue"
	import Cookies from 'js-cookie'
	import { toLogin } from '../../../assets/js/utils'
  export default {
    name: 'community-recommend-list',
    mixins: [envMixin, loginMixin, communityMixin, userMixin],
    data() {
      return {
        tabList: [
          {label: '讨论'},
          {label: '攻略'}
        ], // tab的数据
        topicList: [], // 话题列表
        topicPage: 1,
        currentTab: 0, // 当前选中的tab
        newPage: 1, // 动态的页数
        blogPage: 1, // 攻略的分页当前页
        // messageCount: 0, // 消息通知数
        options: {
          pullUpLoad: true, // 上拉加载
          pullDownRefresh: {
            txt: '刷新成功'
          }    // 下拉刷新
        }, // scroll 事件配置
        loadingShow: true,
        releaseState: false, // 发布弹窗
        scrollEvents: ['scroll'],
        scrollY: 0,
        currentIndex: 0,
        bigImgState: false,//
        imgIndex: 0,
        imgList: [],
        isLogin:false,
      }
    },
    async created(){
			// 各种小程序根据jwt&&jwt_timestamp 自动登录
      await this.miniprogramAutoLogin();
      //如果是从微信模板消息进来的  并且是未登录
      if(this.$route.query.templatemessage === 'true' && !this.alreadyLogged){
        this.needLogin()
      }
		},
    async activated() {
      if (this.$route.query.currentTab) {
        this.currentTab = Number(this.$route.query.currentTab)
      }
      // 获取本人身份验证信息
      this.getAccountUser();
      // 文章详情页点赞分享之后返回列表页同步点赞分享数量
      let isLikedObj = this.$db.ls.get('_is_liked');
      let isShareObj = this.$db.ls.get('_share_count');
      let isCollectionObj = this.$db.ls.get('_is_collected');
      if (isLikedObj || isShareObj || isCollectionObj) {
        this.newList.forEach(item => {
          if (isLikedObj && item.id === isLikedObj.id) {
            item.my_status.has_liked = isLikedObj.has_liked;
            item.my_status.has_liked ? item.like_count += 1 : item.like_count -= 1;
          }
          if (isShareObj && item.id === isShareObj.id) {
            item.share_count = isShareObj.count ? isShareObj.count : item.share_count;
          }
          if (isCollectionObj && item.id === isCollectionObj.id) {
            item.my_status.has_collected = isCollectionObj.has_collected;
            item.my_status.has_collected ? item.collect_count += 1 : item.collect_count -= 1;
          }
        })
        this.$db.ls.remove('_is_liked')
        this.$db.ls.remove('_share_count')
        this.$db.ls.remove('_is_collected')
      }
      // await this.getRecommendNews({ refresh: true, payload: { page: 1 } })
      this.$refs.topicScroll && this.$refs.topicScroll.refresh()
      this.$refs.newListScroll && this.$refs.newListScroll.refresh()
    },
    async mounted() {
      try {
        await this.loginByWx()
        this.getAccountUser()
        this.getUnViewCount()
        this.getTopics({refresh: true})
        this.getBlogData({refresh: true, payload: {page: 1}})
        await this.getRecommendNews({refresh: true, payload: {page: 1}})
        this.loadingShow = false
        if (!this.$db.ls.get('identity') && this.cvAccountToken) {
          await community.createCommunityInfo(this.cvAccountToken)
          this.$db.ls.set('identity', true)
        }
        this.$nextTick(() => {
          let els = document.querySelectorAll('.community-item-desc')
          for (let i = ((Math.floor(els.length / 10) == 0 ? 0 : Math.floor(els.length / 10) - 1) * 10); i < els.length; i++) {
            if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
              addClass(document.querySelectorAll('.community-item-desc')[i], 'community-content-clip')
              addClass(document.querySelectorAll('.more-item')[i], 'more-item-show')
            } else {
              removeClass(document.querySelectorAll('.community-item-desc')[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.more-item')[i], 'more-item-show')
            }
          }
        })
      } catch (e) {
        console.error(e)
      }
    },
    computed: {
      ...mapState('community', ['newList', 'newTotal', 'blogList', 'blogTotal', 'blogTags', 'headImages', 'messageCount', 'isReflash']),
      // 加载更多的loading
      moreLoadingShow() {
        return (this.currentTab === 0 && (this.newList.length < this.newTotal)) || (this.currentTab === 1 && (this.blogList.length < this.blogTotal))
      },
      // 没有更多的显示状态
      noMoreShow() {
        return (this.currentTab === 0 && (this.newList.length === this.newTotal)) || (this.currentTab === 1 && (this.blogList.length === this.blogTotal))
      }
    },
    watch: {
      isReflash(newValue) {
        this.onPullingDown(true)
        this.$refs.newListScroll && this.$refs.newListScroll.scrollTo(0, 0, 1000)
      },
      newList() {
        this.$nextTick(() => {
          let els = document.querySelectorAll('.community-item-desc')
          for (let i = ((Math.floor(els.length / 10) == 0 ? 0 : Math.floor(els.length / 10) - 1) * 10); i < els.length; i++) {
            if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
              addClass(document.querySelectorAll('.community-item-desc')[i], 'community-content-clip')
              addClass(document.querySelectorAll('.more-item')[i], 'more-item-show')
            } else {
              removeClass(document.querySelectorAll('.community-item-desc')[i], 'community-content-clip')
              removeClass(document.querySelectorAll('.more-item')[i], 'more-item-show')
            }
          }
        })
      },
      currentTab(value) {
        if (value == 0) {
          this.$nextTick(() => {
            let els = document.querySelectorAll('.community-item-desc')
            for (let i = 0; i < els.length; i++) {
              if (Number(getComputedStyle(els[i]).height.replace("px", "")) > 96) {
                addClass(document.querySelectorAll('.community-item-desc')[i], 'community-content-clip')
                addClass(document.querySelectorAll('.more-item')[i], 'more-item-show')
              } else {
                removeClass(document.querySelectorAll('.community-item-desc')[i], 'community-content-clip')
                removeClass(document.querySelectorAll('.more-item')[i], 'more-item-show')
              }
            }
          })
        }
      }
    },
    components: {
      WTab,
      WTabBar,
      communityItem,
      blogItem,
      WNoMore,
      WMoreLoading,
      WLoading,
      Release,
      WPopup,
      WNoResults,
      BigImgPopup,
      BigImg,
      WUserDialog
    },
    methods: {
      ...mapActions('community', ['getRecommendNews', 'getBlogData', 'getUnViewCount']),
      // 跳转到系统消息页
      goToMessage() {
        this.$router.push('/system/message')
      },
      toSearchPage() {
        this.$router.push(`/community/search`)
      },
      // 跳转攻略详情
      toBlogDetail(item) {
        this.$db.ls.set('shareNeed', true)
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/blog-detail/blog-detail?url=${process.env.VUE_APP_HOST}/community/blog/${item.token}&title=${item.title}`
          })
        } else {
          this.$router.push(`/community/blog/${item.token}`)
        }
      },
      // 处理滚动事件
      scrollHandler({y}) {
        this.scrollY = -y
      },
      // 关闭发布弹窗
      closeRelease(state, obj, scroll) {
        this.releaseState = false
        if (state === 'success') {
          this.$createToast({
            txt: '发布成功',
            time: 1000,
            type: 'correct'
          }).show()
          this.newList.unshift(obj)
          // 发布完成之后滚动到列表顶部
          if (scroll) {
            this.$refs.newListScroll.scrollTo(0, 0)
          }
        }
      },
      // 切换攻略tag
      changeTag(item, index) {
        this.currentIndex = index
        this.blogPage = 1
        this.getBlogData({refresh: true, payload: {page: 1, tag: item.name}})
      },
      // 切换tab
      changeTab(tab, index) {
        this.currentTab = index
      },
      // 跳转话题聚合页
      toTopicDetail(item) {
        this.$db.ls.set('shareNeed', true)
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/news-group/news-group?url=${process.env.VUE_APP_HOST}/community/topic/${item.id}&title=${item.name}&image=${item.image}`
          })
        } else {
          this.$router.push(`/community/topic/${item.id}`)
        }
      },
      // 获取话题列表
      async getTopics({refresh}) {
        let res = await this.$api.bbs.getTopics({
          page: this.topicPage,
          size: 100
        })
        if (res.code === 1000) {
          this.topicList = res.data.topics
        }
      },
      // 下拉刷新
      onPullingDown(isReflash) {
        this.getUnViewCount();
        if (this.currentTab === 0) {
          this.newPage = 1
          this.getRecommendNews({refresh: true, payload: {page: this.newPage, refresh: 1}})
        } else if (this.currentTab === 1) {
          this.blogPage = 1
          this.getBlogData({refresh: true, payload: {page: this.blogPage}})
        }
        // 点击TabBar刷新不走计数接口
        if (!isReflash) {
          try {
            bbsApi.pullCount()
          } catch (e) {
            console.log("计数异常")
          }
        }
        this.$createToast({
          txt: '为你更新一组新内容',
          time: 1500,
          type: 'txt'
        }).show()
      },
      // 上拉加载
      onPullingUp() {
        if (this.currentTab === 0 && !this.noMoreShow) {
          this.newPage += 1
          this.getRecommendNews({refresh: false, payload: {page: this.newPage}})
        } else if (this.currentTab === 1 && !this.noMoreShow) {
          this.blogPage += 1
          this.getBlogData({refresh: false, payload: {page: this.blogPage}})
        }
      },
      showBigImg({index, list}) {
        this.bigImgState = true
        this.imgIndex = index
        this.imgList = list
      },
      //跳转至登录
      toLogin () {
			  if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/login/login`
          })
        }else {
          toLogin()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/variable";
  @import "../../../assets/scss/global/mixin";

  .community-list-container {
    background-color: #F9F9F9;
    height: $screen-height;
    overflow: hidden;
    @include ipx-content-bottom(54px);

    .community-header {
      height: 50px;
      padding: 0 24px;
      background-color: $color-light;

      .tab-wrapper {
        /*width: 88px;*/
        height: 100%;

        .tab {
          display: flex;
          align-items: center;
        }

        /deep/ .tab-item {
          font-size: $font-size-medium;
          color: $color-dark-gray;
          line-height: 20px;
          margin-right: 24px;
          width: 32px;
          justify-content: center;
          height: 100%;
          white-space: nowrap;
        }

        /deep/ .active {
          font-size: $font-size-large;
          font-weight: 600;
          color: $color-title;
          //position: relative;
          margin-bottom: -8px;

          &::after {
            //position: absolute;
            //bottom: 2px;
            margin-top: 8px;
            /*display: none;*/
          }
        }
      }

      .community-header-middle {
        width: 170px;
        padding-left: 16px;
        height: 28px;
        border-radius: 12px;
        //background-color: #F4F4F4;
        margin-right: 26px;
        display: flex;
        justify-content: flex-end;

        .search-placeholder {
          color: #9c9c9c;
          font-size: $font-size-small;
          margin-left: 8px;
        }

        .iconfont {
          font-size: 24px;
          color: #606060;
          font-weight: 600;
        }
      }

      .community-message {
        position: relative;

        .iconfont {
          font-size: 24px;
          //color: $color-title;
          color: #606060;
        }

        .message-total {
          position: absolute;
          top: -6px;
          color: $color-light;
          border-radius: 8px;
          background-color: $color-theme;
          font-size: $font-size-small;
          padding: 2.2px;
          min-width: 16px;
          min-height: 16px;
        }
      }
    }

    .community-message-notice-container {
      padding-top: 16px;
      background-color: $color-light;

      .community-message-notice {
        background-color: rgba($color: #000, $alpha: .8);
        padding: 8px 16px;
        border-radius: 6px;
        color: $color-light;
        width: fit-content;
      }
    }

    .community-list-content {
      height: calc(calc(var(--vh, 1vh) * 100) - 38px);
      @include ipx-content-bottom(54px);

      .topic-content {
        padding-top: 16px;
        background-color: $color-light;

        .topic-item {
          width: 120px;
          height: 50px;
          margin-right: 8px;

          &:first-child {
            margin-left: 24px;
          }

          &:last-child {
            margin-right: 24px;
          }

          .topic-item-text {
            position: relative;
            width: 100%;
            height: 100%;
            border-radius: 8px;
            .topic-text{
              position: absolute;
              left: 8px;
              bottom: 8px;
              font-size: 12px;
              color:#fff;
              font-weight: 400;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 6px;
            }

            span {
              position: absolute;
              bottom: 16px;
              padding: 0 6px;
              text-align: center;
              white-space: pre-wrap;
              color: $color-light;
            }
          }
        }
      }

      .head-images-content {
        padding: 18px 0;

        .head-image-container {
          width: 100vw;
          box-sizing: border-box;
          .head-image-item {
            height: 140px;
            border-radius: 6px;
            width: calc(100vw - 48px);
            /*margin: 0 24px;*/
          }
        }

        /deep/ .cube-slide-dots {
          padding-bottom: 6px;

          .my-dot {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #C4C4C6;
            margin-right: 10px;
            padding-bottom: 6px;

            &:last-child {
              margin-right: 0;
            }
          }

          .active {
            background-color: $color-light;
          }
        }
      }

      .tags-wrapper {
        padding: 10px 0;
        background-color: $color-light;

        .tag-item {
          margin-right: 20px;
          background-color: $color-light;
          color: $color-title;

          &:first-child {
            margin-left: 24px;
          }

          &:last-child {
            margin-right: 24px;
          }
        }

        .tag-item-active {
          font-size: $font-size-medium-x;
          color: $color-theme;
        }
      }
    }

    .community-add {
      position: fixed;
      bottom: 120px;
      right: 24px;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      z-index: 199;
      //background-color: $color-light;
      background-image: linear-gradient(#ff9f79, #ff6644);
      box-shadow: 0px 6px 8px 0px rgba(255, 102, 68, 0.18);

      .iconfont {
        color: $color-light;
        font-weight: 600;
        font-size: 18px;
      }
    }

    .horizontal-scroll-list-wrap {
      /deep/ .cube-scroll-content {
        display: inline-block;
      }

      .list-wrapper {
        white-space: nowrap;
      }

      .list-item {
        display: inline-block;
      }
    }
  }

  .blog-container {
    background-color: $color-light;
  }
  .unLogin{
    width: 100%;
    height: 244px;
    position: fixed;
    bottom: 47px;
    left: 0;
    z-index: 1000;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 40%,#FFFFFF 100%);
    box-sizing: border-box;
    span{
      text-align: center;
      background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
      border-radius: 21px;
      padding: 13px 52px;
      color: #fff;
      display: block;
      width:50%;
      margin: 0 auto;
      margin-top: 130px;
      font-size: 16px;
    }
    p{
      text-align: center;
      color: #9C9C9C;
      font-size: 14px;
      margin-top: 15px;
    }
  }
</style>
